import { styled } from "@mui/material/styles"
import { Box, Paper, Typography } from "@mui/material"

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  paddingBottom: theme.spacing(2)
}))

export const StyledServiceInfoBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  boxShadow: "none"
}))

export const StyledInfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(1),
  "&:last-child": {
    marginBottom: 0
  }
}))

export const StyledInfoLabel = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body2.fontSize
}))

export const StyledInfoValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize
}))

export const StyledWarningBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.warning.light,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.warning.main}`,
  marginTop: theme.spacing(2)
}))

export const StyledWarningText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium
}))

export const StyledFormSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5)
}))

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1)
}))

export const StyledCalculationBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.primary.light + "20",
  border: `1px solid ${theme.palette.primary.main}40`,
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(1)
}))

export const StyledInstructionsBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(1)
}))
